<template>
	<div style="width: 100%;">
		<div style="width: 100%;" :class="{isfull:po != 'top'}">
			<div style="width: 100%;" id="navTop">
				<!-- <el-row type="flex" > -->
				<div id="position" style="width: 1px;"></div>
				<el-row :id="containerItem.preStyle.sticky?'navbar':''" style="margin: auto;"
					v-if="containerItem.applyType == 'all' || containerItem.applyType == equipment"
					v-for="(containerItem,containerIndex) in list" :key="containerIndex" :style="equipment == 'pc' && !containerItem.isFullWidth && !containerItem.isFullWidthBg?{width:boxStyleOne.width
					}:{width:'100%'}">
					<el-col :span="getSpan(containerItem,containerItem)">
						<!-- <div style="width: 100%;" v-if="containerItem.preStyle.sticky" class="position hidecss" id="position">
						</div> -->
						<!-- <div style="position: absolute;width: 100vw;height: 100px;background-color: aquamarine;
						margin: auto;z-index: -1;left: 50%; transform: translate(-50%, -50%);
						"></div> -->
						<!-- boxStyleTwo -->
						<!-- :class="{'navbar':containerItem.preStyle.sticky}" -->
						<!-- <div v-if="containerItem.preStyle.sticky" :style="{
						}" style="width: 100%;height: 100px;background-color: antiquewhite;position: fixed;top: 0px;left:0px">
							123
						</div> -->
						<div :style="{...cssStringToObject(getStyle(containerItem,'noFull'))}">
							<div :style="containerItem.isFullWidthBg?getStyle(containerItem,'full'):''"
								style="">
								<div :style="containerItem.containerLayout.col.span == 24 && equipment == 'pc' && !containerItem.isFullWidth?{width:boxStyleOne.width}:'100%'"
									style="margin: auto;max-width: 100%;">
									<div :style="getStyle(containerItem,'full')">
										<el-row :align="containerItem.containerLayout.align"
											:justify="containerItem.containerLayout.justify"
											style="display: flex;flex-wrap: wrap;width: 100%;" type="flex">
											<el-col :pull="getPull(childItem,containerItem)"
												:push="getPush(childItem,containerItem)"
												v-for="(childItem,childIndex) in containerItem.children"
												:key="childIndex" :span="getSpan(containerItem,childItem,childIndex)">
												<div style="z-index: 10;width: 100%;" :key="childIndex">
													<div :style="getStyle(childItem)">
														<div style="margin: auto;">
															<el-row :align="containerItem.containerLayout.align"
																:justify="childItem.containerLayout.justify" type="flex"
																style="margin: 0px;display: flex;flex-wrap: wrap;width: 100%;">
																<el-col
																	:pull="childrenTwoItem.containerLayout.col.pull == 0?null:childrenTwoItem.containerLayout.col.pull"
																	:push="childrenTwoItem.containerLayout.col.push == 0?null:childrenTwoItem.containerLayout.col.push"
																	:span="getSpan(childItem,childrenTwoItem,childrenTwoIndex)"
																	v-for="(childrenTwoItem,childrenTwoIndex) in childItem.children">
																	<!-- v-if="childrenTwoItem.compontChildren.length != 0 && equipment == 'phone' && po != 'top'?($route.path.indexOf('/checkout') == -1 && $route.path.indexOf('/carts') == -1):true" -->
																	<div :key="childrenTwoIndex" style="z-index: 10;">
																		<div :style="{...getStyleComponentFather(childItem)}"
																			style="height: 100%;width: 100%;display: flex;overflow: hidden;"
																			class="container-child"
																			
																			:key="compontChildrenIndex"
																			v-for="(compontChildrenItem,compontChildrenIndex) in childrenTwoItem.compontChildren">
																			<div :style="{
																			justifyContent:childrenTwoItem.containerLayout.justify,
																			...getComponentStyle(childrenTwoItem)
																		}" style="width: 100%;display: flex;height: 100%;">
																				<component
																					:key="compontChildrenIndex"
																				 :translate_list="translate_list"
																				:translate_status="translate_status"
																				@loadData="loadDataComp"
																				@noLoadData="noLoadDataComp"
																					@changePage="changePage" 
																				 :all_setting="all_setting"
																					:guides="guides"
																					:systemConfig="systemConfig"
																					:type="typeView"
																					:equipment="equipment"
																					:compontentStyle="childrenTwoItem.preStyle.compontentStyle"
																					:selectdItem="childrenTwoItem"
																					:style="{
																					'justify-content':childrenTwoItem.containerLayout.justify,
																					...getChildConentStyle(childrenTwoItem)
																				}" v-if="compontChildrenItem.compoentName" style="height: 100%;width: 100%;display: flex;"
																					:is="compontChildrenItem.compoentName">
																				</component>
																			</div>
																		</div>
																	</div>
																</el-col>
															</el-row>
														</div>
													</div>
												</div>
											</el-col>
										</el-row>
									</div>
								</div>
							</div>
						</div>
					</el-col>
				</el-row>

				<!-- </el-row> -->

			</div>
		</div>
	</div>
</template>

<script>
	// 自动导入组件
	const components = require.context(
		"./", //组件所在目录的相对路径
		true, //是否查询其子目录
		/\w+.vue$/ //匹配基础组件文件名的正则表达式
	);
	const comObj = {};
	components.keys().forEach(fileName => {
		if (fileName != 'preview') {
			// 获取文件名
			var names = fileName.split("/").pop().replace(/.\w+$/, "");
			names = 'wm' + names.charAt(0).toUpperCase() + names.slice(1);
			// 获取组件配置
			const comp = components(fileName);
			// 若该组件是通过"export default"导出的，优先使用".default"，否则退回到使用模块的根
			comObj[names] = comp.default || comp;
		}
	});
	console.log('comObj', comObj)
	export default {
		components: {
			...comObj
		},
		props: {
			
			
			translate_status: {
				type: String,
				default: '0'
			},
			translate_list: {
				type: Array,
				default: () => {
					return []
				}
			},
			
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			guides: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			po: {
				type: String,
				default: ''
			},
			typeView: {
				type: String,
				default: 'preview'
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Array,
				default: () => {
					return []
				}
			},
			equipment: {
				type: String,
				default: 'pc'
			}
		},
		
		data() {
			return {
				navBoxWidth: "100%",
				fontList: [],
				navShow: true,
				collapse: true,
				// equipment: 'pc'
			}
		},
		watch: {
			all_setting: {
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					if (newVal.length > 0) {
						let itemSetFont = newVal[0].tabList[1]
						this.fontList = itemSetFont.config.setfontFamily.fontList
					}
				}
			},
			// boxStyleOne: {
			// 	immediate: true,
			// 	deep: true,
			// 	handler: function(newVal, oldVal) {
			// 		console.log('boxStyleOne', newVal)
			// 	}
			// },
			// boxStyleTwo: {
			// 	immediate: true,
			// 	deep: true,
			// 	handler: function(newVal, oldVal) {
			// 		console.log('boxStyleTwo', newVal)
			// 	}
			// }
		},
		mounted() {
			try {
				console.log('this.all_settingp', this.all_setting)
				let setItem = this.all_setting[0].tabList[0].config.nav
				let style = {}
				if (setItem.bg.setWidth.type == 'px') {
					style.width = setItem.bg.setWidth.width
				} else {
					style.width = "100%"
				}
				this.navBoxWidth = style.width
			} catch (e) {

			}

			this.upDateLayout()

		},
		updated() {
			this.upDateLayout()
		},
		methods: {
			loadDataComp() {
				this.$emit('loadDataComp')
			},
			noLoadDataComp(){
				this.$emit('noLoadDataComp')
			},
			changePage(e) {
				this.$emit('changePage',e)
			},
			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},
			getStyle(e, type) {
				let style = {}
				
				if (type == 'noFull') {
					let padding = {
						paddingTop: e.preStyle.padding[0] + 'px',
						paddingBottom: e.preStyle.padding[1] + 'px',
						paddingLeft: e.preStyle.padding[2] + 'px',
						paddingRight: e.preStyle.padding[3] + 'px'
					}
					let margin = {
						marginTop: e.preStyle.margin[0] + 'px',
						marginBottom: e.preStyle.margin[1] + 'px',
						marginLeft: e.preStyle.margin[2] + 'px',
						marginRight: e.preStyle.margin[3] + 'px'
					}
					// background-image: url(https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png);
					let backgroundImage = `url(${e.preStyle.bg.img })`
					let backgroundRepeat = e.preStyle.bg.type

					let boxShadow =
						`${e.preStyle.boxShadow.h}px ${e.preStyle.boxShadow.v}px ${e.preStyle.boxShadow.blur}px ${e.preStyle.boxShadow.spread}px ${e.preStyle.boxShadow.color}`
					if (e.preStyle.boxShadow.type != 'outset') {
						boxShadow = `${boxShadow} ${e.preStyle.boxShadow.type}`
					}
					style = {
						...style,
						...padding,
						...margin,
						// backgroundImage,
						// backgroundRepeat,
						boxShadow
					}
					
					if (e.preStyle.bg.bgtype == 'color') {
						let background =
							`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`
						if (e.preStyle.background.color1 && e.preStyle.background.color2) {
							style.background = background
						}
					}
					
					if (e.preStyle.bg.bgtype && e.preStyle.bg.bgtype == 'img') {
						if (e.preStyle.bg.img) {
					
							let backgroundImage = `url(${e.preStyle.bg.img})`
					
							if (e.preStyle.bg.bgImgWidth) {
								style.backgroundSize = e.preStyle.bg.bgImgWidth + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (e.preStyle.bg.bgImgHeigth) {
								style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.bg.bgImgHeigth + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (e.preStyle.bg.type) {
								style.backgroundRepeat = e.preStyle.bg.type
							}
							if (e.preStyle.bg.position) {
								style.backgroundPosition = e.preStyle.bg.position
							}
							style.backgroundImage = backgroundImage
							if (e.preStyle.bg.type) {
								style.backgroundRepeat = e.preStyle.bg.type
							}
						} else {
					
						}
					}
					
					
					if (e.preStyle.border.borderSize) {
						style.borderTop =
							`${e.preStyle.border.type} ${e.preStyle.border.borderSize[0]}px ${e.preStyle.border.color}`
						style.borderLeft =
							`${e.preStyle.border.type} ${e.preStyle.border.borderSize[1]}px ${e.preStyle.border.color}`
						style.borderBottom =
							`${e.preStyle.border.type} ${e.preStyle.border.borderSize[2]}px ${e.preStyle.border.color}`
						style.borderRight =
							`${e.preStyle.border.type} ${e.preStyle.border.borderSize[3]}px ${e.preStyle.border.color}`
					}

					if (e.preStyle.border.borderRadius) {
						style.borderRadius =
							`${e.preStyle.border.borderRadius[0]}px ${e.preStyle.border.borderRadius[1]}px ${e.preStyle.border.borderRadius[2]}px ${e.preStyle.border.borderRadius[3]}px`
					}
					if (e.preStyle.sticky) {
						// style.position = 'sticky'
						// style.top = "20px"
						// console.log('e.preStyle.stickye.preStyle.stickye.preStyle.stickye.preStyle.stickye.preStyle.sticky', e
						// 	.preStyle.sticky)
					}
					let str = ''
					for (let k in style) {
						str = str + k + ':' + style[k] + ';'
					}
					return str
				}
				if (type == 'full') {
					if (e.preStyle.bg.bgtype == 'color') {
						let background =
							`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`
						if (e.preStyle.background.color1 && e.preStyle.background.color2) {
							style.background = background
						}
					}

					if (e.preStyle.bg.bgtype && e.preStyle.bg.bgtype == 'img') {
						if (e.preStyle.bg.img) {

							let backgroundImage = `url(${e.preStyle.bg.img})`

							if (e.preStyle.bg.bgImgWidth) {
								style.backgroundSize = e.preStyle.bg.bgImgWidth + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (e.preStyle.bg.bgImgHeigth) {
								style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.bg.bgImgHeigth + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (e.preStyle.bg.type) {
								style.backgroundRepeat = e.preStyle.bg.type
							}
							if (e.preStyle.bg.position) {
								style.backgroundPosition = e.preStyle.bg.position
							}
							style.backgroundImage = backgroundImage
							if (e.preStyle.bg.type) {
								style.backgroundRepeat = e.preStyle.bg.type
							}
						} else {

						}
					}
					let str = ''
					for (let k in style) {
						str = str + k + ':' + style[k] + ';'
					}
					if (e.preStyle.bg.bgtype == 'gradient') {
						str = str + e.preStyle.bg.bgGradient
					}

					console.log('strstrstrstr', str)
					return str
				}



				let margin = {
					marginTop: e.preStyle.margin[0] + 'px',
					marginBottom: e.preStyle.margin[1] + 'px',
					marginLeft: e.preStyle.margin[2] + 'px',
					marginRight: e.preStyle.margin[3] + 'px'
				}
				// background-image: url(https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png);
				let backgroundImage = `url(${e.preStyle.bg.img })`
				let backgroundRepeat = e.preStyle.bg.type

				let boxShadow =
					`${e.preStyle.boxShadow.h}px ${e.preStyle.boxShadow.v}px ${e.preStyle.boxShadow.blur}px ${e.preStyle.boxShadow.spread}px ${e.preStyle.boxShadow.color}`
				if (e.preStyle.boxShadow.type != 'outset') {
					boxShadow = `${boxShadow} ${e.preStyle.boxShadow.type}`
				}
				style = {
					...style,
					// ...padding,
					...margin,
					// backgroundImage,
					// backgroundRepeat,
					boxShadow
				}
				if (e.preStyle.border.borderSize) {
					style.borderTop =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[0]}px ${e.preStyle.border.color}`
					style.borderLeft =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[1]}px ${e.preStyle.border.color}`
					style.borderBottom =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[2]}px ${e.preStyle.border.color}`
					style.borderRight =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[3]}px ${e.preStyle.border.color}`
				}

				if (e.preStyle.border.borderRadius) {
					style.borderRadius =
						`${e.preStyle.border.borderRadius[0]}px ${e.preStyle.border.borderRadius[1]}px ${e.preStyle.border.borderRadius[2]}px ${e.preStyle.border.borderRadius[3]}px`
				}
				if (e.preStyle.sticky) {
					// style.position = 'sticky'
					// style.top = "20px"
					// console.log('e.preStyle.stickye.preStyle.stickye.preStyle.stickye.preStyle.stickye.preStyle.sticky', e
					// 	.preStyle.sticky)
				}
				if (e.preStyle.bg.bgtype == 'color') {
					let background =
						`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`
					if (e.preStyle.background.color1 && e.preStyle.background.color2) {
						style.background = background
					}
				}

				if (e.preStyle.bg.bgtype && e.preStyle.bg.bgtype == 'img') {
					if (e.preStyle.bg.img) {

						let backgroundImage = `url(${e.preStyle.bg.img})`

						if (e.preStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.bg.bgImgHeigth + 'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.bg.type
						}
						if (e.preStyle.bg.position) {
							style.backgroundPosition = e.preStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.bg.type
						}
					} else {

					}
				}
				let str = ''
				for (let k in style) {
					str = str + k + ':' + style[k] + ';'
				}
				if (e.preStyle.bg.bgtype == 'gradient') {
					str = str + e.preStyle.bg.bgGradient
				}

				console.log('strstrstrstr', str)
				return str
				// return style
			},



			upDateLayout() {
				let that = this
				this.$nextTick(() => {
					
					// console.log('navbarnavbar',document.getElementsByClassName('navbar'))
					//  let position = document.getElementById('position')
					//  let navbarList = 
					 
					 
					 console.log('this.pothis.po', this.po)
					if(this.po == 'top') {
						let navTop = document.getElementById('navTop')
						if(navTop) {
							console.log('navTopnavTopnavTop', navTop.offsetHeight)
						}
					}
					 
					 
					let navbar = document.getElementById('navbar')
					console.log('navbarnavbar',navbar)
					let position = document.getElementById('position')
					if (navbar && position) {
						let navbarTop = navbar.offsetTop; // 获取导航栏到父元素的顶部距离
						
						console.log('upDateLayoutnavbar', navbar)
						console.log('navbarTop', navbarTop)
						window.onscroll = function() {
							// 获取滚动条距离顶部的距离
							var scrollTop = document.documentElement.scrollTop || window.pageYOffset ||
								document.body.scrollTop;
							// 滚动高度>元素距离顶部的位置时添加类，否则移除类
							scrollTop > navbarTop ? navbar.classList.add('fixed') : navbar.classList.remove(
								'fixed')

							if (scrollTop > navbarTop) {
								position.style.height = navbar.offsetHeight + 'px'
							} else {
								position.style.height = '0px'
							}

							if (scrollTop > navbarTop) {
								// alert(that.navBoxWidth)
								// navbar.style.width = that.navBoxWidth + 'px'
								
								// navbar.style.width = '100%'

							} else {
								// navbar.style.width = '100vw'
							}
							// // 控制占位内容是否显示
							scrollTop > navbarTop ? position.classList.remove('hidecss') : position.classList
								.add('hidecss')
						}

					}

				})
				// this.$nextTick(() => {
				// 	console.log(123)
				// 	var navbar = document.getElementById('navbar')
				// 	var position = document.getElementById('position')
				// 	var botCart = document.getElementById('botCart')
				// 	console.log('botCart', botCart)
				// 	if (botCart) {
				// 		botCart.classList.add('bto-fixed')
				// 	}

				// 	if (position) {
				// 		console.log('navbar', navbar.classList)
				// 		console.log('updated navbar', navbar.offsetHeight)
				// 		// console.log('position')
				// 		var navbarTop = navbar.offsetTop; // 获取导航栏到父元素的顶部距离
				// 		position.style.height = navbar.offsetHeight + 'px'
				// 		console.log('position', position.style.height)
				// 		// 监听滚动
				// 		window.onscroll = function() {
				// 			// 获取滚动条距离顶部的距离
				// 			var scrollTop = document.documentElement.scrollTop || window.pageYOffset ||
				// 				document.body
				// 				.scrollTop;
				// 			// 滚动高度>元素距离顶部的位置时添加类，否则移除类
				// 			scrollTop > navbarTop ? navbar.classList.add('fixed') : navbar.classList.remove(
				// 				'fixed')
				// 			if (scrollTop > navbarTop) {
				// 				// alert(that.navBoxWidth)
				// 				navbar.style.width = that.navBoxWidth + 'px'

				// 			} else {
				// 				navbar.style.width = '100vw'
				// 			}
				// 			// // 控制占位内容是否显示
				// 			scrollTop > navbarTop ? position.classList.remove('hidecss') : position.classList
				// 				.add('hidecss')
				// 		}
				// 	}
				// })
			},
			changeEq(e) {
				this.equipment = e
				console.log("changeEq this.equipment ", this.equipment)
			},
			getChildConentStyle(e) {

				// 	console.log('getChildConentStyle e', e)
				// 	// console.log('getChildConentStyle this.selectdItem', this.selectdItem)
				// 	// console.log('getChildConentStyle this.centerList', this.centerList)
				// 	// 文字渐变
				// 	let style = {}
				// 	if (e.preStyle.compontentStyle.needHW && this.equipment == 'pc') {
				// 		if(e.preStyle.compontentStyle.percentWidthSwitch) {
				// 			style.width = '100%'
				// 		}else {
				// 			style.width = e.preStyle.compontentStyle.width + 'px'
				// 		}

				// 		style.height = e.preStyle.compontentStyle.height + 'px'
				// 	}
				// 	if (e.preStyle.compontentStylePhone.needHW && this.equipment == 'phone') {
				// 		if(e.preStyle.compontentStylePhone.percentWidthSwitch) {
				// 			style.width = '100%'
				// 		}else {
				// 			style.width = e.preStyle.compontentStylePhone.width + 'px'
				// 		}
				// 		style.height = e.preStyle.compontentStylePhone.height + 'px'
				// 	}



				// 	let background =
				// 		`linear-gradient(${e.preStyle.font.background.angle}deg ,${e.preStyle.font.background.color1}, ${e.preStyle.font.background.color2})`
				// 	if (e.preStyle.font.background.color1 && e.preStyle.font.background.color2) {
				// 		style.background = background
				// 		style.backgroundClip = 'text'
				// 		style.color = 'transparent'
				// 	}
				// 	console.log('getChildConentStylestyle',e.preStyle.compontentStylePhone.percentWidthSwitch)
				// 	console.log('getChildConentStylestyle',style)
				// 	return style
			},
			getFontStyle(e) {
				let item;
				console.log('getFontStyle', this.fontList)
				this.fontList.forEach(fontItem => {
					if (fontItem.name == e) {
						item = fontItem
					}
				})
				if (item) {
					if (!document.getElementById(item.name)) {
						var style = document.createElement('style');
						style.type = 'text/css';
						style.id = item.name
						style.innerHTML = item.css;
						document.getElementsByTagName('HEAD').item(0).appendChild(style);
					}
				}
			},
			getComponentStyle(e) {
				console.log('getComponentStyle e', e)
				let style = {}
				// 设置字体
				let fontSize = `${e.preStyle.font.size}px`
				let fontWeight = e.preStyle.font.weight
				let color = `${e.preStyle.font.color}`
				// 背景渐变
				// 设置宽高
				let width = ""
				let height = ""
				// style.borderRadius = e.preStyle.border.radius + 'px'
				// if (e.preStyle.border.color) {
				// 	style.border = e.preStyle.border.type + " " + e.preStyle.border.color + " " + e.preStyle.border.px +
				// 		"px"
				// }
				let boxShadow =
					`${e.preStyle.boxShadow.h}px ${e.preStyle.boxShadow.v}px ${e.preStyle.boxShadow.blur}px ${e.preStyle.boxShadow.spread}px ${e.preStyle.boxShadow.color}`
				if (e.preStyle.boxShadow.type != 'outset') {
					boxShadow = `${boxShadow} ${e.preStyle.boxShadow.type}`
				}
				let backgroundRepeat = e.preStyle.bg.type

				let margin = {
					marginTop: e.preStyle.margin[0] + 'px',
					marginBottom: e.preStyle.margin[1] + 'px',
					marginLeft: e.preStyle.margin[2] + 'px',
					marginRight: e.preStyle.margin[3] + 'px'
				}
				let padding = {
					paddingTop: e.preStyle.padding[0] + 'px',
					paddingBottom: e.preStyle.padding[1] + 'px',
					paddingLeft: e.preStyle.padding[2] + 'px',
					paddingRight: e.preStyle.padding[3] + 'px'
				}
				style = {
					color,
					// background,
					fontWeight,
					fontSize,
					// width,
					// height,
					...style,
					backgroundRepeat,
					boxShadow,
					...margin,
					...padding,
					whiteSpace: 'nowrap'
				}

				if (e.preStyle.border.borderSize) {
					style.borderTop =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[0]}px ${e.preStyle.border.color}`
					style.borderLeft =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[1]}px ${e.preStyle.border.color}`
					style.borderBottom =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[2]}px ${e.preStyle.border.color}`
					style.borderRight =
						`${e.preStyle.border.type} ${e.preStyle.border.borderSize[3]}px ${e.preStyle.border.color}`
				}


				if (e.preStyle.border.borderRadius) {
					style.borderRadius =
						`${e.preStyle.border.borderRadius[0]}px ${e.preStyle.border.borderRadius[1]}px ${e.preStyle.border.borderRadius[2]}px ${e.preStyle.border.borderRadius[3]}px`
				}

				if (e.preStyle.font.fontFamily) {
					this.getFontStyle(e.preStyle.font.fontFamily)
					style.fontFamily = e.preStyle.font.fontFamily
				}
				console.log('style', style)
				if (e.preStyle.font.italic) {
					style.fontStyle = 'italic'
				}
				if (e.preStyle.font.fontFamily) {
					// font-family
					style.fontFamily = e.preStyle.font.fontFamily
					console.log('e.preStyle.font.fontFamily', e.preStyle.font.fontFamily)
				}

				let background =
					`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`

				if (e.preStyle.background.color1 && e.preStyle.background.color2 && e.preStyle.bg.bgtype == 'color') {
					style.background = background
				}

				if (e.preStyle.bg.bgtype && e.preStyle.bg.bgtype == 'img') {
					if (e.preStyle.bg.img) {

						let backgroundImage = `url(${e.preStyle.bg.img})`

						if (e.preStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.bg.bgImgHeigth + 'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.bg.type
						}
						if (e.preStyle.bg.position) {
							style.backgroundPosition = e.preStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.bg.type
						}
					} else {
						let background =
							`linear-gradient(${e.preStyle.background.angle}deg,${e.preStyle.background.color1},${e.preStyle.background.color2})`
						if (e.preStyle.background.color1 && e.preStyle.background.color2) {
							style.background = background
						}
					}
				}
				// let str = ''
				// for(let k in style) {
				// 	str =str + k + ':' + style[k] + ';'
				// }
				if (e.preStyle.bg.bgtype == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(e.preStyle.bg.bgGradient)
					}

				}

				// if (e.preStyle.bg.img) {
				// 	style.backgroundImage = backgroundImage
				// }
				// if (e.preStyle.bg.type == "no-repeat-t") {
				// 	style.backgroundRepeat = "no-repeat-t"
				// 	style.backgroundSize = 'cover'
				// }
				// console.log('getComponentStyle style', style)
				return style
			},

			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},
			getChildConentStyle(e) {
				console.log('getChildConentStyle e', e)
				// console.log('getChildConentStyle this.selectdItem', this.selectdItem)
				// console.log('getChildConentStyle this.centerList', this.centerList)
				// 文字渐变
				let style = {}
				// if (e.preStyle.compontentStyle.needHW && this.equipment == 'pc') {
				// 	if(e.preStyle.compontentStyle.percentWidthSwitch) {
				// 		style.width = '100%'
				// 	}else {
				// 		style.width = e.preStyle.compontentStyle.width + 'px'
				// 	}

				// 	style.height = e.preStyle.compontentStyle.height + 'px'
				// }
				// if (e.preStyle.compontentStylePhone.needHW && this.equipment == 'phone') {
				// 	if(e.preStyle.compontentStylePhone.percentWidthSwitch) {
				// 		style.width = '100%'
				// 	}else {
				// 		style.width = e.preStyle.compontentStylePhone.width + 'px'
				// 	}
				// 	style.height = e.preStyle.compontentStylePhone.height + 'px'
				// }



				// let background =
				// 	`linear-gradient(${e.preStyle.font.background.angle}deg ,${e.preStyle.font.background.color1}, ${e.preStyle.font.background.color2})`
				// if (e.preStyle.font.background.color1 && e.preStyle.font.background.color2) {
				// 	style.background = background
				// 	style.backgroundClip = 'text'
				// 	style.color = 'transparent'
				// }
				// console.log('getChildConentStylestyle',e.preStyle.compontentStylePhone.percentWidthSwitch)
				console.log('getChildConentStylestyle1', style)
				return style
			},
			getStyleComponentFather(e) {
				let style = {}


				// if (this.all_setting.length > 0) {
				// 	let itemSetFont = this.all_setting[0].tabList[1]
				// 	e.preStyle.font.color = itemSetFont.config.color
				// 	e.preStyle.font.size = parseInt(itemSetFont.config.fontSize)
				// 	e.preStyle.font.fontFamily = itemSetFont.config.fontFamily
				// 	// childItem.preStyle.size
				// }


				if (e.preStyle.font.color) {
					style.color = e.preStyle.font.color
				}
				if (e.preStyle.font.fontFamily) {
					style.fontFamily = e.preStyle.font.fontFamily
				}
				if (e.preStyle.font.size) {
					console.log('getStyleComponentFatherstyle e', e)
					style.fontSize = e.preStyle.font.size
				}

				return style
			},
			getPull(childItem, item) {
				console.log('itemitem item ', item)
				console.log('getPull childItem ', childItem)
				console.log(childItem.containerLayout.col.switch)
				if (this.equipment == "pc") {
					if (item.containerLayout.col.switch) {
						return childItem.containerLayout.col.pull == 0 ? null : childItem.containerLayout.col.pull
					}
				} else {
					if (item.containerLayout.phoneCol.switch) {
						return childItem.containerLayout.phoneCol.pull == 0 ? null : childItem.containerLayout.phoneCol
							.pull
						// return childItem.containerLayout.col.pull == 0 ? null : childItem.containerLayout.col.pull
					}
					// if (childItem.containerLayout.phoneCol.switch) {
					// 	return childItem.containerLayout.phoneCol.pull == 0 ? null : childItem.containerLayout.phoneCol.pull
					// }
				}

			},
			getPush(childItem, item) {
				// console.log('getPush childItem ', childItem)
				if (this.equipment == "pc") {
					if (item.containerLayout.col.switch) {
						return childItem.containerLayout.col.push == 0 ? null : childItem.containerLayout.col.push
					}
				} else {
					if (item.containerLayout.phoneCol.switch) {
						return childItem.containerLayout.phoneCol.push == 0 ? null : childItem.containerLayout.phoneCol
							.push
					}
				}
			},
			getSpan(item, childItem) {
				let column = 24
				console.log('getSpan item', item)
				if (this.equipment == "pc") {
					// 首先判断当前的col的switch 状态
					if (item.containerLayout.col.switch) {
						column = childItem.containerLayout.col.span
					} else {
						column = column / item.containerLayout.pcMax
					}
				} else {
					if (item.containerLayout.phoneCol.switch) {
						column = childItem.containerLayout.phoneCol.span
					} else {
						column = column / item.containerLayout.phoneMax
					}
				}
				console.log('column', column)
				return column
			},
		}
	}
</script>

<style scoped>
	.isfull {
		width: 100vw;
		margin: auto;
	}

	.other {
		position: relative;
		z-index: 50;
	}

	.navbar {
		z-index: 100;
		width: 100%;
	}

	.position {
		width: 100%;
	}


	.fixed {
		position: fixed;
		top: 0;
		z-index: 100;
		left: 50%;
		/* 定位到父容器中间 */
		transform: translateX(-50%);
		/* 向左回退自身宽度的一半 */
	}

	.hidecss {
		display: none
	}

	.bto-fixed {
		position: fixed;
		bottom: 0px;
		left: 0px;
		z-index: 1000;

	}
</style>